module.exports = __webpack_public_path__ + "img/homebanner3-compressed.571ad8c3.jpg";